// extracted by mini-css-extract-plugin
module.exports = {"guide":"GoodsB_guide__37S12","intro":"GoodsB_intro__xfwTL","intro_1":"GoodsB_intro_1__3GubE"};